module.exports = __webpack_public_path__ + "img/52.9684ec0a.jpg";